import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ezsServiceIds } from "../../config/UserServicesList";
import { ApplicationState } from "../../store";
import * as CSIDActions from "../../store/csid/actions";
import { ICSIDUserStatus } from "../../store/csid/types";
import { useAreServicesActive } from "../../util/CommonServices";
import EZSCreditAuthentication from "../Credit/Auth/EZSCreditAuthentication";
import IDFCreditAuthentication from "../Credit/Auth/IDFCreditAuthentication";

const CMServiceAuth = () => {
    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );

    const dispatch = useDispatch();
    const getUserCSIDStatus = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus());
    const refreshContext = () => dispatch(CSIDActions.actionCreators.componentNeedsRefresh());

    const creditMonitoringServiceList = [
        ezsServiceIds.tuEnhancedCreditAlerts,
        ezsServiceIds.tuOneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
        ezsServiceIds.financialAccountMonitoring,
    ];

    const isCreditMonitoringActive = useAreServicesActive(creditMonitoringServiceList);

    const ezsCreditAuthSuccessCallBack = (callbackObj: any) => {
        getUserCSIDStatus();
        refreshContext();
    };

    const closeDisclosureDialogCallBack = (callbackObj: any) => {
        refreshContext();
    };

    useEffect(() => {
        getUserCSIDStatus();
    }, []);

    return (
        <React.Fragment>
            {isCreditMonitoringActive && csidUserStatus && csidUserStatus["auth-status"] && csidUserStatus["auth-status"].trim().toUpperCase() !== "AUTHENTICATED" && (
                <div className="box">
                    <div className="box-header"></div>
                    <div className="box-content">
                        {csidUserStatus.l3AuthProvider.isTU || csidUserStatus.l3AuthProvider.isIDF ? (
                            <IDFCreditAuthentication
                                initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                creditAuthCallback={ezsCreditAuthSuccessCallBack}
                                displayFlowAsDialog={true}
                            />
                        ) : (
                            <EZSCreditAuthentication
                                initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                creditAuthCallback={ezsCreditAuthSuccessCallBack}
                                displayFlowAsDialog={true}
                                onCloseCallback={closeDisclosureDialogCallBack}
                                l3Case={"credit-service"}
                                componentParent={"dashboard"}
                            />
                        )}
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default CMServiceAuth;
